import * as React from 'react'

import classNames from 'classnames/bind'
import type moment from 'moment'

import { observer } from 'mobx-react'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import type { TeamViewEmployee } from 'modules/calendar/components/TeamView'
import Store from 'modules/calendar/components/TeamView/components/Store'
import TableBody from 'modules/calendar/components/TeamView/components/TableBody'
import TableHeader from 'modules/calendar/components/TeamView/components/TableHeader'

import styles from './index.module.css'

const cx = classNames.bind(styles)

interface Props {
  date: moment.Moment
  employees: TeamViewEmployee[]
  changingData?: boolean
  employeesWorkingDays: Record<string, string>
  scrollListener: () => void
  paginationInfo: { hasMore?: boolean; [key: string]: unknown } | null | undefined
}

const TeamViewTable = ({
  date,
  changingData = false,
  employees,
  employeesWorkingDays,
  scrollListener,
  paginationInfo,
}: Props) => {
  const { access } = useCurrentSession()
  const [scrollWrapper, setScrollWrapper] = React.useState<HTMLDivElement | null>(null)

  const store = React.useMemo(() => new Store(date, employees, access), [date, employees, access])

  return (
    <div
      className={cx('wrapper', {
        changingData,
      })}
      style={{
        height: '100%',
        width: '100%',
      }}
      ref={setScrollWrapper}
    >
      <table className={styles.table}>
        <TableHeader store={store} />
        <TableBody
          store={store}
          employees={employees}
          employeesWorkingDays={employeesWorkingDays}
          scrollListener={scrollListener}
          paginationInfo={paginationInfo}
          scrollWrapper={scrollWrapper}
        />
      </table>
    </div>
  )
}

export default observer(TeamViewTable)
